import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInstagram = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.13636 3C4.855 3 3 4.855 3 7.13636V12.8636C3 15.145 4.855 17 7.13636 17H12.8636C15.145 17 17 15.145 17 12.8636V7.13636C17 4.855 15.145 3 12.8636 3H7.13636ZM13.8182 5.54545C14.1682 5.54545 14.4545 5.83182 14.4545 6.18182C14.4545 6.53182 14.1682 6.81818 13.8182 6.81818C13.4682 6.81818 13.1818 6.53182 13.1818 6.18182C13.1818 5.83182 13.4682 5.54545 13.8182 5.54545ZM10 6.5C11.9314 6.5 13.5 8.06864 13.5 10C13.5 11.9314 11.9314 13.5 10 13.5C8.06864 13.5 6.5 11.9314 6.5 10C6.5 8.06864 8.06864 6.5 10 6.5ZM10 7.13636C8.42182 7.13636 7.13636 8.42182 7.13636 10C7.13636 11.5782 8.42182 12.8636 10 12.8636C11.5782 12.8636 12.8636 11.5782 12.8636 10C12.8636 8.42182 11.5782 7.13636 10 7.13636Z",
		fill: "#0D2976"
	})
});
export default SvgInstagram;
